<template>
    <div v-if="open" class="popup alert-block">
        <div @click="closePopup" class="bg_popup"></div>
        <div @click="closePopup" class="btn-close"></div>
        <div class="alert-body">
            <div class="alert-title">
                <h2>{{alert_title}}</h2>
                <p>{{alert_text}}</p>
            </div>
            <div class="alert-footer">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                <button @click="confirmAlert" class="btn btn-primary">Delete</button>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../bus';
export default {
    data(){
        return{
            open: false,
            action: '',
            typeinformation: '',
            alert_title: '',
            alert_text: '',
        }
    },
    methods:{
        closePopup(){
            this.open = false;
            bus.$emit('resultalert', {
                action: this.action,
                confirm: false
            });
        },
        confirmAlert(){
            this.open = false;
            bus.$emit('resultalert', {
                action: this.action,
                confirm: true                
            });
        }
    },
    mounted(){
        bus.$on('openalert', (data) => {
            this.open = data.open;
            this.action = data.action;            
            if(data.alert_title){
                this.alert_title = data.alert_title;
            }
            if(data.alert_text){
                this.alert_text = data.alert_text;
            }
        });
    },
}
</script>

<style scoped>

</style>
